module.exports = __webpack_public_path__ + "img/lazienka.9dd86105.svg";